import * as React from "react";
const SvgFiRrToiletPaperUnder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-toilet-paper-under_svg__a)">
      <path
        fill="#062147"
        d="M17 7c.552 0 1 .672 1 1.5s-.448 1.5-1 1.5-1-.672-1-1.5.448-1.5 1-1.5M7.5 7h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2M24 21.346A2.657 2.657 0 0 1 21.347 24H13c-2.757 0-5-2.243-5-5v-2H5c-2.804 0-5-3.733-5-8.5S2.196 0 5 0h12c2.804 0 5 3.733 5 8.5 0 0-.005 8.882-.01 9.065-.028 1.121.042 1.203.269 1.293 1.058.423 1.741 1.399 1.741 2.488M17 2c-1.419 0-3 2.669-3 6.5s1.581 6.5 3 6.5 3-2.669 3-6.5S18.419 2 17 2M5 15h8.745c-1.005-1.449-1.657-3.573-1.736-6h-1.008a1 1 0 1 1 0-2h1.075c.202-2.008.806-3.754 1.67-5H5C3.775 2 2.429 3.99 2.084 7H3a1 1 0 1 1 0 2h-.991c.13 3.561 1.634 6 2.991 6m17 6.346c0-.322-.25-.537-.483-.63-1.592-.636-1.554-2.119-1.525-3.202.004-.167.009-2.17.009-2.17-.83 1.044-1.865 1.655-3 1.655h-7v2c0 1.654 1.346 3 3 3h8.347c.36 0 .653-.293.653-.654z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-toilet-paper-under_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToiletPaperUnder;
